import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _InsightsIcon, _CloseIcon;
import React, { useEffect, useState, useCallback, useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import InsightsIcon from '@mui/icons-material/Insights';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var InsightsDrop = function InsightsDrop(props) {
  var _buttonRef$current;
  var closeDrop = props.closeDrop,
    hasInsightData = props.hasInsightData,
    insightDropContent = props.insightDropContent,
    maxDropHeight = props.maxDropHeight,
    page = props.page,
    setIsInsightsButtonClicked = props.setIsInsightsButtonClicked,
    setIsInsightsDropOpen = props.setIsInsightsDropOpen;
  var _useState = useState(window.innerHeight - 61),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var id = anchorEl ? 'insight-icon-button' : undefined;
  var onClose = useCallback(function () {
    setAnchorEl(null);
    if (setIsInsightsDropOpen) setIsInsightsDropOpen(false);
    if (setIsInsightsButtonClicked) setIsInsightsButtonClicked(false);
  }, [setIsInsightsDropOpen, setIsInsightsButtonClicked]);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    userVisitedInsights = _useState6[0],
    setUserVisitedInsights = _useState6[1];
  var buttonRef = useRef(null);
  var onInsightIconClickHandler = useCallback(function (e) {
    setAnchorEl(e.currentTarget);
    if (!userVisitedInsights) {
      setUserVisitedInsights(true);
    }
    if (setIsInsightsDropOpen) setIsInsightsDropOpen(true);
    if (setIsInsightsButtonClicked) setIsInsightsButtonClicked(true);
  }, [setIsInsightsButtonClicked, setIsInsightsDropOpen, userVisitedInsights]);
  useEffect(function () {
    if (page !== '') {
      if (!anchorEl) {
        setAnchorEl(buttonRef == null ? void 0 : buttonRef.current);
      }
      if (!userVisitedInsights) {
        setUserVisitedInsights(true);
      }
      if (setIsInsightsDropOpen) setIsInsightsDropOpen(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  useEffect(function () {
    if (!anchorEl) {
      setAnchorEl(buttonRef == null ? void 0 : buttonRef.current);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonRef.current]);
  useEffect(function () {
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeDrop]);
  useEffect(function () {
    setMaxHeight(window.innerHeight - 61);
    var handleWindowResize = function handleWindowResize() {
      setMaxHeight(window.innerHeight - 61);
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-describedby": id,
      className: "iconButton",
      "data-name": "Quick-Insights_Popup",
      "data-testid": "insights-message-queue-btn",
      onClick: onInsightIconClickHandler,
      ref: buttonRef,
      sx: {
        marginLeft: '4px!important'
      },
      "data-element": "IconButton",
      "data-source-file": "InsightsDrop.tsx",
      children: _InsightsIcon || (_InsightsIcon = /*#__PURE__*/_jsx(InsightsIcon, {
        "data-element": "InsightsIcon",
        "data-source-file": "InsightsDrop.tsx"
      }))
    }), /*#__PURE__*/_jsxs(StylePopover, {
      anchorEl: (_buttonRef$current = buttonRef == null ? void 0 : buttonRef.current) != null ? _buttonRef$current : anchorEl,
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      anchorReference: "anchorEl",
      id: id,
      onClose: onClose,
      open: userVisitedInsights,
      sx: {
        '& .MuiPopover-paper': {
          height: "".concat(maxDropHeight ? maxDropHeight + 260 : maxHeight, "px !important"),
          maxHeight: maxDropHeight ? maxDropHeight + 260 : maxHeight
        },
        display: "".concat(anchorEl && hasInsightData !== null ? 'block' : 'none')
      },
      transformOrigin: {
        horizontal: 'right',
        vertical: 'top'
      },
      "data-element": "StylePopover",
      "data-source-file": "InsightsDrop.tsx",
      children: [/*#__PURE__*/_jsx(StyledCloseIconButton, {
        "data-name": "Quick-insights_Close",
        onClick: onClose,
        "data-element": "StyledCloseIconButton",
        "data-source-file": "InsightsDrop.tsx",
        children: _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx(CloseIcon, {
          "data-element": "CloseIcon",
          "data-source-file": "InsightsDrop.tsx"
        }))
      }), insightDropContent]
    })]
  });
};
var StyledCloseIconButton = styled(IconButton)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.spacing(0.4),
    position: 'absolute',
    right: '1rem',
    top: '1rem',
    zIndex: 0
  };
});
var StylePopover = styled(Popover)(function () {
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiOutlinedInput-root': {
      fontSize: 14,
      height: 24,
      textAlign: 'right',
      width: 96
    },
    '& .MuiPaper-root': {
      boxShadow: 'none'
    },
    '& .MuiPopover-paper': {
      borderRadius: 6,
      boxShadow: '0 0 16px 0 rgba(24, 75, 157, 0.24)',
      left: 'initial !important',
      minHeight: '500px',
      overflow: 'hidden',
      right: '18px !important',
      top: '56px !important',
      width: 'auto'
    }
  };
});